import { render, staticRenderFns } from "./CustomerSearchSidebar.vue?vue&type=template&id=fbcca072&scoped=true"
import script from "./CustomerSearchSidebar.vue?vue&type=script&lang=js"
export * from "./CustomerSearchSidebar.vue?vue&type=script&lang=js"
import style0 from "./CustomerSearchSidebar.vue?vue&type=style&index=0&id=fbcca072&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcca072",
  null
  
)

export default component.exports